import { vFocus } from '~/directives/vFocus';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('focus', vFocus);
});
